import { fieldset } from "@launchos/components/ui/theme";

export default { fieldset };
